/* This example requires Tailwind CSS v2.0+ */
import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import SVG from 'react-inlinesvg';
import { GatsbyImage } from 'gatsby-plugin-image';
import tw from 'twin.macro';

const StyledSVG = styled(SVG)`
  fill: ${(props) => props.$fillColor};
`;

const NavLogoContainer = styled.div`
  ${tw`flex justify-center items-center content-center`}
`;

const NavbarPrimaryLogo = ({ sanity }) => {
  const { logos } = sanity;

  const imageType = logos?.navbar?.imageType;
  const pngImage = () => (
    <div className="h-full w-full">
      <GatsbyImage
        image={logos?.navbar?.asset?.gatsbyImageData}
        alt={logos?.navbar?.alt}
        loading="eager"
        className="h-full w-full object-contain transition hover:scale-110"
      />
    </div>
  );
  const svgImage = () => (
    <div className="h-12 w-auto">
      <StyledSVG
        src={logos?.navbar?.asset?.url}
        alt={logos?.navbar?.alt}
        className="h-full w-full object-cover transition hover:scale-105"
      />
    </div>
  );

  return (
    <NavLogoContainer>
      <Link to="/">
        {imageType === 'png' || imageType === 'jpg' ? pngImage() : svgImage()}
      </Link>
    </NavLogoContainer>
  );
};

export { NavbarPrimaryLogo };
